import i18n from '@/i18n'
import DonMessage from "@/util/message/message";

// 整车
import { dealerAuditApi } from "@/api/feedback";
import { dealerAuditKDApi } from "@/api/qualityKD";

// 经销商认可
export function dealerAccept(_this, data) {
  _this.$confirm(`${i18n.t("restockInfo.rkTip")}`, i18n.t("zlfk.rk"), {
    confirmButtonText: i18n.t("home.confirm"),
    cancelButtonText: i18n.t("seek.cancel"),
    type: 'warning'
  }).then(() => {
    let formData = {
      nowTaskId: data.nowTaskId,
      questionId: data.questionId,
      taskDefKey: data.userTaskId,
      variables: {
        approval: true
      },
    }
    dealerAuditApi(formData).then(res => {
      if (res.status == 0) {
        DonMessage.success(_this.examineTip);
        _this.$router.go(-1);
      } else {
        DonMessage.error(res.message);
      }
    })
  })
}

// 经销商驳回
export function dealerReject(_this, data, type) {
  let formData = {
    nowTaskId: data.nowTaskId,
    questionId: data.questionId,
    taskDefKey: data.userTaskId,
    auditText: data.auditText,
    variables: {
      approval: false
    },
  }
  dealerAuditApi(formData).then(res => {
    if (res.status == 0) {
      if (type == "cancel") {
        DonMessage.success(`${i18n.t("zlfk.wt")} ${data.questionNum} ${i18n.t("request.cancelOk")}`);
      } 
      if (type == 'reject') {
        _this.dialogVisible = false;
        DonMessage.success(_this.examineTip);
      }
      _this.$router.go(-1);
    } else {
      DonMessage.error(res.message);
    }
  })
}

// 经销商取消
export function dealerCancel(_this, data, type) {
  _this.$confirm(`${i18n.t("restockInfo.cancelTip")}`, i18n.t("seek.cancel"), {
    confirmButtonText: i18n.t("home.confirm"),
    cancelButtonText: i18n.t("seek.cancel"),
    type: 'warning'
  }).then(() => {
    dealerReject(_this, data, type);
  })
}


// KD
// KD经销商认可
export function kdDealerAccept(_this, data) {
  _this.$confirm(`${i18n.t("restockInfo.rkTip")}`, i18n.t("zlfk.rk"), {
    confirmButtonText: i18n.t("home.confirm"),
    cancelButtonText: i18n.t("seek.cancel"),
    type: 'warning'
  }).then(() => {
    let formData = {
      nowTaskId: data.nowTaskId,
      questionId: data.questionId,
      taskDefKey: data.userTaskId,
      variables: {
        approval: true
      },
    }
    dealerAuditKDApi(formData).then(res => {
      if (res.status == 0) {
        DonMessage.success(_this.examineTip);
        _this.$router.go(-1);
      } else {
        DonMessage.error(res.message);
      }
    })
  })
}

// KD经销商驳回
export function kdDealerReject(_this, data, type) {
  let formData = {
    nowTaskId: data.nowTaskId,
    questionId: data.questionId,
    taskDefKey: data.userTaskId,
    auditText: data.auditText,
    // reasonAnalystData: this.form,
    variables: {
      approval: false
    },
  }
  dealerAuditKDApi(formData).then(res => {
    if (res.status == 0) {
      if (type == "cancel") {
        DonMessage.success(`${i18n.t("zlfk.wt")} ${data.questionNum} ${i18n.t("request.cancelOk")}`);
      }
      if (type == "reject") {
        _this.dialogVisible = false;
        DonMessage.success(_this.examineTip);
      }
      _this.$router.go(-1);
    } else {
      DonMessage.error(res.message);
    }
  })
}

// KD经销商取消
export function kdDealerCancel(_this, data, type) {
  _this.$confirm(`${i18n.t("restockInfo.cancelTip")}`, i18n.t("seek.cancel"), {
    confirmButtonText: i18n.t("home.confirm"),
    cancelButtonText: i18n.t("seek.cancel"),
    type: 'warning'
  }).then(() => {
    kdDealerReject(_this, data, type);
  })
}